/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const upload_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.75 11.75 12 7.5m0 0 4.25 4.25M12 7.5V21M4 2.75h16"
    />
  </svg>
)
export default upload_medium
